// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"dc303e56","529":"15f4a230"}[chunkId] + ".css";
};